import type { ReactElement } from 'react';
import styles from './PinEntryScreen.module.css';

const DIGIT_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'] as const;

export interface NumericKeypadProps {
  disabled: boolean;
  canConfirm: boolean;
  onDigit: (digit: string) => void;
  onBackspace: () => void;
  onConfirm: () => void;
}

/**
 * Teclado numérico virtual dedicado da tela de PIN (HUB-235, CA-08): 0-9 +
 * Backspace + Enter, touch target >=44x44px (52x52 recomendado em
 * tablet/kiosk via CSS), navegável por Tab (ordem do DOM). O teclado físico
 * é tratado pelo componente pai (`PinEntryScreen`, CA-09) — este componente
 * só expõe os botões.
 */
export function NumericKeypad({
  disabled,
  canConfirm,
  onDigit,
  onBackspace,
  onConfirm,
}: NumericKeypadProps): ReactElement {
  return (
    <div className={styles.keypad} role="group" aria-label="Teclado numérico">
      {DIGIT_KEYS.map((digit) => (
        <button
          key={digit}
          type="button"
          className={styles.key}
          aria-label={`Dígito ${digit}`}
          disabled={disabled}
          onClick={() => onDigit(digit)}
        >
          {digit}
        </button>
      ))}

      <button
        type="button"
        className={styles.key}
        aria-label="Backspace"
        disabled={disabled}
        onClick={onBackspace}
      >
        ⌫
      </button>

      <button
        type="button"
        className={styles.key}
        aria-label="Dígito 0"
        disabled={disabled}
        onClick={() => onDigit('0')}
      >
        0
      </button>

      <button
        type="button"
        className={`${styles.key} ${styles.confirmKey}`}
        aria-label="Confirmar PIN"
        disabled={disabled || !canConfirm}
        onClick={onConfirm}
      >
        ✔
      </button>
    </div>
  );
}
